import React, { Component } from 'react'
//import PropTypes from 'prop-types'
import { Form } from 'react-final-form'
import { withRouter } from 'react-router'
import { withTranslation } from 'react-i18next'
import compose from '@shopify/react-compose'

import PasswordRecovery from './password-recovery-view'
import ValidationCode from './validation-code'
import ConfirmationItem from 'components/confirmation-item'

import { withEndUser, ContentBox } from '@portal/kit/pkg/components'
import { requestNewUserPassword, passwordRequestValidator } from '@portal/kit/pkg/services'
import { handleServerErrors } from '@portal/kit/pkg/helpers'

class PasswordRecoveryContainer extends Component {
  state = {
    delivery: null,
    email: null,
  }

  requestPassword = async values => {
    try {
      const response = await requestNewUserPassword(
        values.email,
        '/login/password-recovery/:token'
      )
      this.setState({ delivery: response.data.delivery, email: values.email })
    }
    catch(e) {
      return handleServerErrors(e)
    }
  }

  render() {
    const { t } = this.props

    if (this.state.delivery === 'email') {
      return (
        <ContentBox title={t('portal.reset_password.fill_email')}>
          <ConfirmationItem>{t('portal.reset_password.email_sent')}</ConfirmationItem>
        </ContentBox>
      )
    }

    if (this.state.delivery === 'sms') {
      return (
        <ValidationCode email={this.state.email} />
      )
    }

    return (
      <Form
        onSubmit={this.requestPassword}
        validate={passwordRequestValidator}
        render={formProps => <PasswordRecovery {...formProps} />}
      />
    )
  }
}

PasswordRecoveryContainer.propTypes = {

}

export default compose(
  withEndUser,
  withRouter,
  withTranslation(),
)(PasswordRecoveryContainer)
